export default __webpack_public_path__ + "static/media/level6.e3653024.png";